export default function wrapTWithDefaultNs(oldT, defaultNs) {
    if (typeof defaultNs !== 'string')
        return oldT;
    function t(key, query, options) {
        if (key === void 0) { key = ''; }
        var k = Array.isArray(key) ? key[0] : key;
        if (!k.includes(':'))
            k = defaultNs + ":" + k;
        return oldT(k, query, options);
    }
    return t;
}
